/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React from 'react';
import { Route, Redirect } from "react-router-dom";

export default function UnuthenticatedRoute({ component: C, appProps, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          appProps.isAuthenticated
            ? <Redirect
                to={`/dashboard/profile`}
              />
            : <C {...props} {...appProps} />
          }
      />
    );
  }
  


// WEBPACK FOOTER //
// ./src/UnauthenticatedRoute.js